import { render, staticRenderFns } from "./sys-parameter.vue?vue&type=template&id=05b66620&scoped=true"
import script from "./sys-parameter.vue?vue&type=script&lang=js"
export * from "./sys-parameter.vue?vue&type=script&lang=js"
import style0 from "./sys-parameter.vue?vue&type=style&index=0&id=05b66620&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b66620",
  null
  
)

export default component.exports